import React, { useState } from 'react';
import { Button, InlineLoading } from 'carbon-components-react';

const DBYDRelinkEmail: React.FC<Props> = ({
  user,
  isSetEmailLinking,
  onClickRelinkEmail
}) => {
  const [localRelink, setLocalRelink] = useState<boolean>(false);

  const handleRelinkEmailClick = () => {
    setLocalRelink(true);
    onClickRelinkEmail();
  };

  return (
    <div id="dbydRelinkEmail" className="dbyd-relink-email spacing-padding">
      <div className="sub-section-title">BYDA contact email</div>
      <div className="sub-section-description">
        Update my BYDA contact email address to <span>{user?.email}</span>{' '}
        (required)
      </div>
      <div className="action-button-container">
        <Button
          kind="tertiary"
          size="default"
          className="relink-button-size"
          onClick={handleRelinkEmailClick}
          disabled={isSetEmailLinking || localRelink}
        >
          {!isSetEmailLinking && !localRelink ? (
            'Update BYDA contact email'
          ) : (
            <InlineLoading
              description={
                !isSetEmailLinking ? 'Email updated' : 'Updating email...'
              }
              status={!isSetEmailLinking ? 'finished' : 'active'}
              aria-live={'assertive'}
            />
          )}
        </Button>
      </div>
      <div className="section-description">
        Some asset owners respond directly to your BYDA email. We update it so
        all responses are available in SmartwerWX Locate.
      </div>
    </div>
  );
};

interface Props {
  user: any;
  isSetEmailLinking: boolean;
  onClickRelinkEmail: Function;
}

export default React.memo(DBYDRelinkEmail);
